module.exports = __webpack_public_path__ + "img/1.570f8642.jpg";